module.exports = __webpack_public_path__ + "static/2-38b4bc0ca5ee28a84b37eb112688d98a.jpg";